routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.taskList', {
      url: "/consultas/tareas/:id",
      template: `<task-list sh-ctrl="shCtrl"></task-list>`,
    })
	.state('home.taskList2', {
      url: "/consultas/tareas",
      template: `<task-list sh-ctrl="shCtrl"></task-list>`,
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/task-list/task-list.config.js
 **/